import React from 'react';
import Joi from 'joi';
import _ from 'lodash';

import routes from '../../utils/routes';

import Form from '../common/form';
import Progress from '../themed/progress';
import SignaturePreview from '../themed/signature-pad/preview';

import { EXCEL_APPLICATION_TYPE, IMAGE_LIMITS, PDF_APPLICATION_TYPE } from '../../utils/constants';

import * as models from '../../utils/models';
import * as utils from '../../utils/utilities';
import * as data from '../../utils/data';

import * as authService from '../../services/authService';
import * as service from '../../services/reportService';
import * as toastService from '../../services/toastService';

class AcceptReportForm extends Form {
	state = {
		data: { acceptanceStatus: '', reviewComment: '', commentDocumentUrl: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		acceptanceStatus: Joi.string().required().label('Acceptance Status'),
		reviewComment: Joi.string().min(7).required().label('Comments'),
		commentDocumentUrl: Joi.array().min(0).max(1).required().label('Comment Document File'),
	};

	getApiData = () => {
		const pdf: any = _.omit(this.state.data, ['commentDocumentUrl']);

		if (this.state.data.commentDocumentUrl.length > 0) {
			pdf.commentDocumentUrl = (this.state.data.commentDocumentUrl[0] as models.PDFImageProps).src;
		}

		return pdf;
	};

	postData = async (): Promise<void> => {
		const project: models.Project = this.props.project;
		if (!project) return toastService.error('Project not available!');

		await service.acceptReport(project.report._id, this.getApiData(), this.handleProgressChange);

		window.location.href = routes.organizationDashboard.fullPath;
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Submitting Remarks',
			success: 'Remarks Submitted',
			error: utils.getErrorMessage,
		});
	};

	render() {
		const user = authService.getCurrentUser() as models.User;

		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
					<h3 className="form-title">Accept Report </h3>

					{this.renderSelect({
						name: 'acceptanceStatus',
						label: 'Acceptance Status',
						placeholder: 'Do you accept this report?',
						options: data.getAcceptanceOptions(),
					})}

					{this.renderTextArea({
						name: 'reviewComment',
						label: 'Comments',
						rows: '4',
						placeholder: 'Enter Your Comments',
					})}

					<div className="bg-light border mt-2 p-2">
						{this.renderFileInput({
							max: IMAGE_LIMITS.EXCEL_ISO_UPLOAD,
							multiple: IMAGE_LIMITS.EXCEL_ISO_UPLOAD > 1,
							name: 'commentDocumentUrl',
							accept: EXCEL_APPLICATION_TYPE + ',' + PDF_APPLICATION_TYPE,
							label: 'Comment Document (PDF/Excel File)',
							sublabel: 'Upload Comment Document',
							types: [EXCEL_APPLICATION_TYPE, PDF_APPLICATION_TYPE],
						})}
					</div>

					{user.signature && <SignaturePreview signatureUrl={user.signature} />}

					<div className="d-flex justify-content-end">
						{this.renderButton('Submit Review')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default AcceptReportForm;
